import React, { Fragment, useEffect, useContext, ReactNode, useState } from 'react';
import { AuthContext } from "../contexts/auth";
import { Dialog, Menu, Transition } from '@headlessui/react'
import { Bars3CenterLeftIcon, ChatBubbleLeftEllipsisIcon, ClockIcon, HomeIcon, XMarkIcon, UserCircleIcon } from '@heroicons/react/24/outline'
import { ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { menuItems } from '../stores/menuData';
import { Link } from 'wouter';
import { useAtom } from 'jotai';
import { currentPageStore } from '../stores/mainStore';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}


const AuthLayout = ({ children }) => {
  const { profile, token, signOut, isEmployee } = useContext(AuthContext);

  const [sidebarOpen, setSidebarOpen] = useState(false)

  const [currentPage, setCurrentPage] = useAtom(currentPageStore)

  const canViewLivelli = profile.can_purchase

  useEffect(() => {
    const reactTarget = document.getElementById('react-target');

    // Add the class when the component mounts
    if (reactTarget) {
      reactTarget.classList.add('app');
    }

    // Remove the class when the component unmounts
    return () => {
      if (reactTarget) {
        reactTarget.classList.remove('app');
      }
    };
  }, []);

  return (
    <>
      <div className="min-h-full">

        {/* VISUALIZZAZIONE MOBILE */}
        <Transition.Root show={sidebarOpen} as={Fragment}>
          <Dialog as="div" className="relative lg:hidden" style={{ zIndex: '300' }} onClose={setSidebarOpen}>
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
            </Transition.Child>

            <div className="fixed inset-0 z-40 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative flex w-full max-w-xs flex-1 flex-col bg-white pb-4 pt-5">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute right-0 top-0 -mr-12 pt-2">
                      <button
                        type="button"
                        className="relative ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                        onClick={() => setSidebarOpen(false)}
                      >
                        <span className="absolute -inset-0.5" />
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon className="h-6 w-6 text-white" />
                      </button>
                    </div>
                  </Transition.Child>
                  <div className="flex flex-shrink-0 items-center px-4">
                    {/* <img
                      className="h-8 w-auto"
                      src={profile.logo_encoded}
                      alt={profile.employee?.first_name + ' ' + profile.employee?.last_name}
                    /> */}
                    <img
                      className="h-8 w-auto"
                      src="https://consultala.com/static/images/consultala2.png"
                      alt={profile?.company?.name}
                    />
                  </div>
                  <div className="mt-5 h-0 flex-1 overflow-y-auto">
                    <nav className="px-2">
                      <div className="space-y-1">

                        {/* MENù EMPLOYEE VISUALIZZAZIONE MOBILE */}
                        {isEmployee && (
                          <EmployeeLink 
                            currentPage={currentPage} 
                            profile={profile}
                            setCurrentPage={setCurrentPage}
                          />
                        )}

                        {/* MENù CONSULTANT VISUALIZZAZIONE MOBILE */}
                        {profile.customer_type === 'consultant' && (
                          <ConsultantLink
                            currentPage={currentPage} 
                            profile={profile}
                            setCurrentPage={setCurrentPage}
                          />
                        )}

                        {/* MENù COMPANY VISUALIZZAZIONE MOBILE */}
                        {profile.customer_type === 'company' && (
                          <ConsultantLink
                            currentPage={currentPage} 
                            profile={profile}
                            setCurrentPage={setCurrentPage}
                          />
                        )}

                        {/* LINK SUPPORTO  */}
                        {/* <h3 className="mt-4 px-3 text-sm font-medium text-gray-500" id="desktop-teams-headline">
                          Supporto Consultala
                        </h3>
                        <a
                          href={`https://consultala.saladil.com/help/ticket/new?email=${profile?.the_real_user_email}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-indigo-800 hover:bg-gray-50 hover:text-gray-900 group flex items-center rounded-md px-2 py-2 text-sm font-medium"
                        >
                          <ChatBubbleLeftEllipsisIcon className="mr-3 h-6 w-6 flex-shrink-0 text-indigo-800 group-hover:text-indigo-900" />
                          Contattaci
                        </a> */}

                      </div>
                    </nav>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
              <div className="w-14 flex-shrink-0" aria-hidden="true">
                {/* Dummy element to force sidebar to shrink to fit close icon */}
              </div>
            </div>
          </Dialog>
        </Transition.Root>

        {/* VISUALIZZAZIONE DESKTOP - Static sidebar for desktop */}
        <div className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col lg:border-r lg:border-indigo-300 lg:bg-indigo-50 lg:pb-4 lg:pt-5">
          <div className="flex flex-shrink-0 items-center px-6">
            <img
              className="h-8 w-auto"
              src="https://consultala.com/static/images/consultala2.png"
              alt={profile?.company?.name}
            />
          </div>
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="mt-5 flex h-0 flex-1 flex-col overflow-y-auto pt-1">
           
            <Menu as="div" className="relative inline-block px-3 text-left">
              <div>
                <Menu.Button className="group w-full rounded-md bg-gray-100 px-3.5 py-2 text-left text-sm font-medium text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-gray-100">
                  <span className="flex w-full items-center justify-between">
                    <span className="flex min-w-0 items-center justify-between space-x-3">

                      {/* NOME PROFILO EMPLOYEE VISUALIZZAZIONE DESKTOP */}
                      {isEmployee && (
                        <span className="flex min-w-0 flex-1 flex-col">
                          <span className="break-words text-sm font-medium text-gray-900">
                            {profile.employee?.first_name + ' ' + profile.employee?.last_name}
                          </span>
                        </span>
                      )}

                      {/* LOGO E NOME PROFILO CONSULTANT - VISUALIZZAZIONE DESKTOP */}
                      {profile.customer_type === 'consultant' && (
                        <span className="flex items-center space-x-3">
                          {profile.logo_encoded ? (
                            <img
                              className="h-10 w-10 flex-shrink-0 rounded-full bg-gray-300"
                              src={profile.logo_encoded}
                              alt="Your Company Logo"
                            />
                          ) : (
                            <UserCircleIcon className="h-10 w-10 flex-shrink-0 text-gray-500" />
                          )}
                          <span className="flex min-w-0 flex-1 flex-col">
                            <span className="break-words text-sm font-medium text-gray-900">
                              {profile.company?.name}
                            </span>
                          </span>
                        </span>
                      )}

                       {/* LOGO E NOME PROFILO COMPANY - VISUALIZZAZIONE DESKTOP */}
                       {profile.customer_type === 'company' && (
                        <span className="flex items-center space-x-3">
                          {profile.logo_encoded ? (
                            <img
                              className="h-10 w-10 flex-shrink-0 rounded-full bg-gray-300"
                              src={profile?.logo_encoded}
                              alt="Your Company Logo"
                            />
                          ) : (
                            <UserCircleIcon className="h-10 w-10 flex-shrink-0 text-gray-500" />
                          )}
                          <span className="flex min-w-0 flex-1 flex-col">
                            <span className="break-words text-sm font-medium text-gray-900">{profile?.company?.name}</span>
                          </span>
                        </span>
                      )}
                    </span>
                    <ChevronUpDownIcon
                      className="h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                      aria-hidden="true"
                    />
                  </span>
                </Menu.Button>
              </div>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items >
                  <div className="py-1">
                   
                    <MenuItemsProfilo profile={profile} isEmployee={isEmployee} canViewLivelli={canViewLivelli} />

                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="#"
                          onClick={signOut}
                          className={classNames(
                            active ? 'bg-gray-100' : '',
                            'block px-4 py-2 text-sm text-gray-700'
                          )}
                        >
                          Esci
                        </a>
                      )}
                    </Menu.Item>
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
            <nav className="mt-6 px-3">
              <div className="space-y-1">

                {isEmployee && (
                  <EmployeeLink 
                    currentPage={currentPage} 
                    profile={profile}
                    setCurrentPage={setCurrentPage}
                  />  
                )}

                {profile.customer_type === 'consultant' && (
                  <ConsultantLink
                    currentPage={currentPage} 
                    profile={profile}
                    setCurrentPage={setCurrentPage}
                  />
                )}

                {profile.customer_type === 'company' && (
                  <ConsultantLink
                    currentPage={currentPage} 
                    profile={profile}
                    setCurrentPage={setCurrentPage}
                  />
                )}
              </div>

              {/* LINK SUPPORTO  */}
              {/* <h3 className="mt-4 px-3 text-sm font-medium text-gray-500" id="desktop-teams-headline">
                Supporto Consultala
              </h3>
              <a
                href={`https://consultala.saladil.com/help/ticket/new?email=${profile?.the_real_user_email}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-indigo-800 hover:bg-gray-50 hover:text-gray-900 group flex items-center rounded-md px-2 py-2 text-sm font-medium"
              >
                <ChatBubbleLeftEllipsisIcon
                  className="mr-3 h-6 w-6 flex-shrink-0 text-indigo-800 group-hover:text-indigo-900"
                  aria-hidden="true"
                />
                Contattaci
              </a> */}
            </nav>
          </div>
        </div>

        {/* Main column */}
        <div className="flex flex-col lg:pl-64">
          {/* Search header */}
          <div className="sticky top-0 flex h-16 flex-shrink-0 border-b border-gray-200 bg-white lg:hidden" style={{ zIndex: '200' }}>
            <button
              type="button"
              className="border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-purple-500 lg:hidden"
              onClick={() => setSidebarOpen(true)}
            >
              <span className="sr-only">Open sidebar</span>
              <Bars3CenterLeftIcon className="h-6 w-6" aria-hidden="true" />
            </button>
            <div className="flex flex-1 justify-end px-4 sm:px-6 lg:px-8">
              <div className="flex items-center">
                {/* Profile dropdown */}
                <Menu as="div" className="relative ml-3">
                  <div>
                    <Menu.Button className="relative flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2">
                      <span className="absolute -inset-1.5" />
                      <span className="sr-only">Open user menu</span>
                      <span className="flex items-center space-x-3">
                        {profile.customer_type === 'consultant' && (
                          <span className="flex items-center space-x-3">
                            {profile.logo_encoded ? (
                              <img
                                className="h-10 w-10 flex-shrink-0 rounded-full bg-gray-300"
                                src={profile.logo_encoded}
                                alt="Your Company Logo"
                              />
                            ) : (
                              <UserCircleIcon className="h-10 w-10 flex-shrink-0 text-gray-500" />
                            )}
                          </span>
                        )}
                        {profile.customer_type === 'company' && (
                          <span className="flex items-center space-x-3">
                            {profile.logo_encoded ? (
                              <img
                                className="h-10 w-10 flex-shrink-0 rounded-full bg-gray-300"
                                src={profile.logo_encoded}
                                alt="Your Company Logo"
                              />
                            ) : (
                              <UserCircleIcon className="h-10 w-10 flex-shrink-0 text-gray-500" />
                            )}
                          </span>
                        )}
                        {isEmployee && (
                          <span className="flex items-center space-x-3">
                              <UserCircleIcon className="h-10 w-10 flex-shrink-0 text-gray-500" />
                          </span>
                        )}
                      </span>
                    </Menu.Button>
                  </div>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    {/* MENU ITEMS DEL PROFILO */}
                    <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right divide-y divide-gray-200 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <div className="py-1">

                        <MenuItemsProfilo profile={profile} isEmployee={isEmployee} />
                          
                        <Menu.Item>
                          {({ active }) => (
                            <a
                              href="#"
                              onClick={signOut}
                              className={classNames(
                                active ? 'bg-gray-100' : '',
                                'block px-4 py-2 text-sm text-gray-700'
                              )}
                            >
                              Esci
                            </a>
                          )}
                        </Menu.Item>
                      </div>
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>
          </div>
          <main className="flex-1">
            {children}
          </main>
        </div>
      </div>
    </>
  )
};

export default AuthLayout;


const EmployeeLink = ({ currentPage, profile, setCurrentPage }) => {
  return (
    <>
      {/* LINK DASHBOARD PERSONALE DELL'EMPLOYEE */}
      <div className="mb-4">
        {menuItems.map((item) => {
          if (item.gestione == 'navigazione') {
            return (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setCurrentPage(item.href)}
                className={classNames(
                  (currentPage == item.href) ? 'bg-indigo-100 text-indigo-900' : 'text-indigo-800 hover:bg-gray-50 hover:text-gray-900',
                  'group flex items-center rounded-md px-2 py-2 text-sm font-medium'
                )}
                aria-current={(currentPage == item.href) ? 'page' : undefined}
              >
                <item.icon
                  className={classNames(
                    (currentPage == item.href) ? 'text-indigo-900' : 'text-indigo-800 group-hover:text-indigo-900',
                    'mr-3 h-6 w-6 flex-shrink-0'
                  )}
                  aria-hidden="true"
                />
                {item.name}
              </Link>
            )
          }
        })}
      </div>


      {/* MENU PERSONALE DEL DIPENDENTE */}
      <div className="">
        <h3 className="mt-4 px-3 text-sm font-medium text-gray-500" id="desktop-teams-headline">
          Area Personale
        </h3>
        {menuItems.map((item) => {
          if (item.gestione == 'areariservata') {
            return (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setCurrentPage(item.href)}
                className={classNames(
                  (currentPage == item.href) ? 'bg-indigo-100 text-indigo-900' : 'text-indigo-800 hover:bg-gray-50 hover:text-gray-900',
                  'group flex items-center rounded-md px-2 py-2 text-sm font-medium'
                )}
                aria-current={(currentPage == item.href) ? 'page' : undefined}
              >
                <item.icon
                  className={classNames(
                    (currentPage == item.href) ? 'text-indigo-900' : 'text-indigo-800 group-hover:text-indigo-900',
                    'mr-3 h-6 w-6 flex-shrink-0'
                  )}
                  aria-hidden="true"
                />
                {item.name}
              </Link>
            )
          }
        })}
      </div>


    {/* EMPLOYEE è MANAGER - AGGIUNTA ITEMS GESTIONE BASE (unità org, lista dip, aggiungi dip, buste paga, CU, docs) */}
    { // BASE
      profile.is_manager && (
        <div className="">
          <h3 className="mt-4 px-3 text-sm font-medium text-gray-500" id="desktop-teams-headline">
            Base
          </h3>
          {menuItems.map((item) => {
            if (item.gestione == 'gestione-base') {
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setCurrentPage(item.href)}
                  className={classNames(
                    (currentPage == item.href) ? 'bg-indigo-100 text-indigo-900' : 'text-indigo-800 hover:bg-gray-50 hover:text-gray-900',
                    'group flex items-center rounded-md px-2 py-2 text-sm font-medium'
                  )}
                  aria-current={(currentPage == item.href) ? 'page' : undefined}
                >
                  <item.icon
                    className={classNames(
                      (currentPage == item.href) ? 'text-indigo-900' : 'text-indigo-800 group-hover:text-indigo-900',
                      'mr-3 h-6 w-6 flex-shrink-0'
                    )}
                    aria-hidden="true"
                  />
                  {item.name}
                </Link>
              )
            }
          })}
        </div>
      )
    }

      {/* EMPLOYEE è MANAGER - AGGIUNTA ITEMS GESTIONE PRESENZE (gestione turni, assegna turni, calendario presenze, richieste giustificativi, avvisi) */}
      { // PRESENZE
        profile.is_manager && (
          <div className="">
            <h3 className="mt-4 px-3 text-sm font-medium text-gray-500" id="desktop-teams-headline">
              Presenze
            </h3>
            {menuItems.map((item) => {
              if (item.gestione == 'gestione-presenze') {
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    onClick={() => setCurrentPage(item.href)}
                    className={classNames(
                      (currentPage == item.href) ? 'bg-indigo-100 text-indigo-900' : 'text-indigo-800 hover:bg-gray-50 hover:text-gray-900',
                      'group flex items-center rounded-md px-2 py-2 text-sm font-medium'
                    )}
                    aria-current={(currentPage == item.href) ? 'page' : undefined}
                  >
                    <item.icon
                      className={classNames(
                        (currentPage == item.href) ? 'text-indigo-900' : 'text-indigo-800 group-hover:text-indigo-900',
                        'mr-3 h-6 w-6 flex-shrink-0'
                      )}
                      aria-hidden="true"
                    />
                    {item.name}
                  </Link>
                )
              }
            })}
          </div>
        )
      }

      {/* EMPLOYEE è MANAGER - AGGIUNTA ITEMS GESTIONE PRESENZE (gestione turni, assegna turni, calendario presenze, richieste giustificativi, avvisi) */}
      { // STRUMENTI - CALCOLO COSTO DEL LAVORO
        profile.is_manager && (
          <div className="">
            <h3 className="mt-4 px-3 text-sm font-medium text-gray-500" id="desktop-teams-headline">
              Strumenti
            </h3>
            {menuItems.map((item) => {
              if (item.gestione == 'strumenti') {
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    onClick={() => setCurrentPage(item.href)}
                    className={classNames(
                      (currentPage == item.href) ? 'bg-indigo-100 text-indigo-900' : 'text-indigo-800 hover:bg-gray-50 hover:text-gray-900',
                      'group flex items-center rounded-md px-2 py-2 text-sm font-medium'
                    )}
                    aria-current={(currentPage == item.href) ? 'page' : undefined}
                  >
                    <item.icon
                      className={classNames(
                        (currentPage == item.href) ? 'text-indigo-900' : 'text-indigo-800 group-hover:text-indigo-900',
                        'mr-3 h-6 w-6 flex-shrink-0'
                      )}
                      aria-hidden="true"
                    />
                    {item.name}
                  </Link>
                )
              }
            })}
          </div>
        )
      }
    </>
  )
}


const ConsultantLink = ({ currentPage, profile, setCurrentPage }) => {
  return (
    <>
      {/* LINK DASHBOARD CONSULTANT/COMPANY */}
      <div className="mb-4">
        {menuItems.map((item) => {
          if (item.gestione == 'navigazione') {
            return (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setCurrentPage(item.href)}
                className={classNames(
                  (currentPage == item.href) ? 'bg-indigo-100 text-indigo-900' : 'text-indigo-800 hover:bg-gray-50 hover:text-gray-900',
                  'group flex items-center rounded-md px-2 py-2 text-sm font-medium'
                )}
                aria-current={(currentPage == item.href) ? 'page' : undefined}
              >
                <item.icon
                  className={classNames(
                    (currentPage == item.href) ? 'text-indigo-900' : 'text-indigo-800 group-hover:text-gray-500',
                    'mr-3 h-6 w-6 flex-shrink-0'
                  )}
                  aria-hidden="true"
                />
                {item.name}
              </Link>
            )
          }
        })}
      </div>

      {/* MENù PRESENZE */}
      <div className="">
        <h3 className="mt-4 px-3 text-sm font-medium text-gray-500" id="desktop-teams-headline">
          Presenze
        </h3>
        {menuItems.map((item) => {
          if (item.gestione == 'presenze') {
            return (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setCurrentPage(item.href)}
                className={classNames(
                  (currentPage == item.href) ? 'bg-indigo-100 text-indigo-900' : 'text-indigo-800 hover:bg-gray-50 hover:text-gray-900',
                  'group flex items-center rounded-md px-2 py-2 text-sm font-medium'
                )}
                aria-current={(currentPage == item.href) ? 'page' : undefined}
              >
                <item.icon
                  className={classNames(
                    (currentPage == item.href) ? 'text-indigo-900' : 'text-indigo-800 group-hover:text-gray-500',
                    'mr-3 h-6 w-6 flex-shrink-0'
                  )}
                  aria-hidden="true"
                />
                {item.name}
              </Link>
            )
          }
        })}
      </div>

      {/* MENù GESTIONE DIPENDENTI  */}
      <div className="">
        <h3 className="mt-4 px-3 text-sm font-medium text-gray-500" id="desktop-teams-headline">
          Dipendenti
        </h3>
        {menuItems.map((item) => {
          if (item.gestione == 'dipendenti') {
            return (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setCurrentPage(item.href)}
                className={classNames(
                  (currentPage == item.href) ? 'bg-indigo-100 text-indigo-900' : 'text-indigo-800 hover:bg-gray-50 hover:text-gray-900',
                  'group flex items-center rounded-md px-2 py-2 text-sm font-medium'
                )}
                aria-current={(currentPage == item.href) ? 'page' : undefined}
              >
                <item.icon
                  className={classNames(
                    (currentPage == item.href) ? 'text-indigo-900' : 'text-indigo-800 group-hover:text-indigo-900',
                    'mr-3 h-6 w-6 flex-shrink-0'
                  )}
                  aria-hidden="true"
                />
                {item.name}
              </Link>
            )
          }
        })}
      </div>

      {/* MENù STRUMENTI  */}
      <div className="">
        <h3 className="mt-4 px-3 text-sm font-medium text-gray-500" id="desktop-teams-headline">
          Strumenti
        </h3>
        {menuItems.map((item) => {
          if (item.gestione == 'strumenti') {
            return (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setCurrentPage(item.href)}
                className={classNames(
                  (currentPage == item.href) ? 'bg-indigo-100 text-indigo-900' : 'text-indigo-800 hover:bg-gray-50 hover:text-gray-900',
                  'group flex items-center rounded-md px-2 py-2 text-sm font-medium'
                )}
                aria-current={(currentPage == item.href) ? 'page' : undefined}
              >
                <item.icon
                  className={classNames(
                    (currentPage == item.href) ? 'text-indigo-900' : 'text-indigo-800 group-hover:text-indigo-900',
                    'mr-3 h-6 w-6 flex-shrink-0'
                  )}
                  aria-hidden="true"
                />
                {item.name}
              </Link>
            )
          }
        })}
      </div>

      {/* MENù GESTIONE DOCUMENTI */}
      <div className="">
        <h3 className="mt-4 px-3 text-sm font-medium text-gray-500" id="desktop-teams-headline">
          Gestione Documenti
        </h3>
        {menuItems.map((item) => {
          if (item.gestione == 'documenti') {
            return (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setCurrentPage(item.href)}
                className={classNames(
                  (currentPage == item.href) ? 'bg-indigo-100 text-indigo-900' : 'text-indigo-800 hover:bg-gray-50 hover:text-gray-900',
                  'group flex items-center rounded-md px-2 py-2 text-sm font-medium'
                )}
                aria-current={(currentPage == item.href) ? 'page' : undefined}
              >
                <item.icon
                  className={classNames(
                    (currentPage == item.href) ? 'text-indigo-900' : 'text-indigo-800 group-hover:text-indigo-900',
                    'mr-3 h-6 w-6 flex-shrink-0'
                  )}
                  aria-hidden="true"
                />
                {item.name}
              </Link>
            )
          }
        })}
      </div>
    </>
  )
}

const MenuItemsProfilo = ({ profile, isEmployee, canViewLivelli }) => { 
  return (
    <>
      <Menu.Item>
        {({ active }) => (
          <>
            {isEmployee ? (
              <Link to="/areariservata/profilo" className="block px-4 py-2 text-sm text-gray-700">
                Profilo
              </Link>
            ) : profile.customer_type === 'consultant' ? (
              <Link to="/profilo" className="block px-4 py-2 text-sm text-gray-700">
                Profilo
              </Link>
            ) : profile.customer_type === 'company' ? (
              <Link to="/profilo" className="block px-4 py-2 text-sm text-gray-700">
                Profilo
              </Link>
            ) : null}
          </>
        )}
      </Menu.Item>

      {profile?.customer_type === 'company' && (profile?.company?.email == profile?.the_real_user_email) && (
        <Menu.Item>
          {({ active }) => (
            <Link to="/profilo/fatturazione" className='block px-4 py-2 text-sm text-gray-700'>
              Profilo Fatturazione
            </Link>
          )}
        </Menu.Item>
      )}
  
      <Menu.Item>
        {({ active }) => (
          <Link 
            to="/livelli" 
            className={`px-4 py-2 text-sm text-gray-700 ${(isEmployee) ? 'hidden' : 'block'}`}
          >
            Abbonamento
          </Link>
        )}
      </Menu.Item>

      {!isEmployee && ( 
        <Menu.Item>
          {({ active }) => (
            <a
              href="https://consultalahr.com/videoguida/"
              target="_blank"
              rel="noopener noreferrer"
              className='block px-4 py-2 text-sm text-gray-700'
            >
              Guida Utente
            </a>
          )}
        </Menu.Item>
      )}

    </>
  );
};
